import BarChartViz from '../vizs/BarChartViz'
import BaseComponent from './BaseComponent'
/**
 * # {componentLabel} (`class {componentClassName}`)
 * A paired column chart displays more than one data series in clustered vertical columns. Each data series shares the same axis labels, so vertical bars are grouped by category. Clustered columns allow the direct comparison of multiple series, but they become visually complex quickly.
 *
 * ### Example Usage
 * ```javascript
 *
 *   import {GroupedBars} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new GroupedBars($el, data, config);
 *
 * ```
 *
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 3 or more columns.
 *
 * Each row represents a group. The first column should be the id/label of the group, and the rest of the columns should represent each of the values of the bars in each group.
 *
 * | category   | value1 |  value2  |  value3  |
 * | --------   | ------ |  ------  |  ------  |
 * |   Jan      |    22.4|      15.4|      43.2|
 * |   Feb      |    52.3|      29.3|      12.8|
 * |   Mar      |    12.8|      34.1|      61.4|
 * |   Apr      |    26.0|      12.3|      14.5|
 *
 * {.data-table}
 *
 * Each column will be assigned a different color, to distinguish them inside of each group.
 *
 */
export default class GroupedBarsComponent extends BaseComponent {
  static vizClass = BarChartViz
  static componentLabel = 'Grouped Bar chart'
  static dataFormat = [
    { index: 0, axis: 'x0', types: [String], role: 'id', roleLabel: 'Category' },
    { index: -1, axis: 'y0', types: [Number, null], role: 'value', roleLabel: 'Group value' },
  ]
  static defaultConfig = {
    title: this.componentLabel,
    mode: 'grouped',
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'],
        nonEditable: true,
      },
    },
    AxisHelper: {
      x: {
        showTickValues: {
          nonEditable: true,
        },
      },
    },
    LegendBehavior: {
      showLegend: {
        value: true,
        nonEditable: false,
      },
    },
    TooltipBehavior: {
      getHtml: function (d) {
        return `
        <div class="tip-value important">${this.valueWithUnit(d.value, 'y')}</div>
        <div class="tip-id">
          <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
            { id: d.parentId }
          )}; margin-right: 3px"></span>
          ${d.parentId}
        </div>
        <div class="secondary">${this.formatValue(d.id, 'x')}</div>`
      },
    },
    // ItemsHelper: {
    //   colorScale: (d)=>{
    //     if(d.id==='X') return '#f00'
    //     else if (d.id==='Y') return '#0f0'
    //     else if (d.id==='Z') return '#00f'
    //     else return '#222'
    //   }
    // }
  }
}
